import { DiscountTypeModel } from '@/models/config'
import { DiscountTypesService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useDiscountType () {
  const discountTypes: Ref<DiscountTypeModel[]> = ref([])

  const getDiscountTypesActivated = async () => {
    discountTypes.value = await DiscountTypesService.getActivated()
  }
  getDiscountTypesActivated()

  const discountTypesOp = computed(() => {
    return discountTypes.value.map(type => {
      return {
        value: type.id,
        text: type.name
      }
    })
  })

  return { discountTypes, discountTypesOp, getDiscountTypesActivated }
}
